import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { DEFAULT_EMPTY_VALUE } from 'src/constants/companyReport';

interface Props {
  activeIndex: string;
  handleOnClick: (index: string) => void;
  detailData: any;
}
const AddtionalInformation = ({ activeIndex, handleOnClick, detailData }: Props) => {
  const additionalInformation = detailData?.companyProfile?.companyProfile?.additionalInformation;

  return (
    <div className={`card accordion ${activeIndex === 'additional-info' ? 'active' : ''}`}>
      <div className="accordion-heading" onClick={() => handleOnClick('additional-info')}>
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-4 align-items-center">
            <h4 className="mb-0">ADDITIONAL INFORMATION</h4>
          </div>
          <div>
            <img
              className="chevron-icon"
              src={require('src/assets/images/icons/chevron-down.svg').default}
              alt="chevron-down icon"
            />
          </div>
        </div>
      </div>
      <div className="accordion-content">
        <Tabs>
          <TabList>
            <Tab>Persons With Significant Control</Tab>
            <Tab>Miscellaneous</Tab>
          </TabList>

          <TabPanel>
            <div className="mt-3">
              <table className="accordion-table sm-th-md-td">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Country Code</th>
                    <th>Country Of Registration</th>
                    <th>Governing Law</th>
                    <th>Kind</th>
                    <th>Legal Form</th>
                    <th>Nature Of Control</th>
                    <th>Person Type</th>
                    <th>Place Registered</th>
                    <th>Registration Number</th>
                  </tr>
                </thead>
                <tbody>
                  {additionalInformation?.personsWithSignificantControl?.activePSC?.map(
                    (ai: any) => (
                      <tr key={ai.notifiedOn + ai.insertDate}>
                        <td>{ai.name ?? DEFAULT_EMPTY_VALUE}</td>
                        <td>{ai.countryCode ?? DEFAULT_EMPTY_VALUE}</td>
                        <td>{ai.countryOfRegistration ?? DEFAULT_EMPTY_VALUE}</td>
                        <td>{ai.governingLaw ?? DEFAULT_EMPTY_VALUE}</td>
                        <td>{ai.kind ?? DEFAULT_EMPTY_VALUE}</td>
                        <td>{ai.legalForm ?? DEFAULT_EMPTY_VALUE}</td>
                        <td>{ai.natureOfControl ?? DEFAULT_EMPTY_VALUE}</td>
                        <td>{ai.personType ?? DEFAULT_EMPTY_VALUE}</td>
                        <td>{ai.placeRegistered ?? DEFAULT_EMPTY_VALUE}</td>
                        <td>{ai.registrationNumber ?? DEFAULT_EMPTY_VALUE}</td>
                      </tr>
                    ),
                  )}
                </tbody>
              </table>
            </div>
          </TabPanel>
          <TabPanel>
            <div className="mt-3">
              <table className="accordion-table sm-th-md-td">
                <thead>
                  <tr>
                    <th>Accounts Due Date</th>
                    <th>Filing Date Of Accounts</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{additionalInformation?.miscellaneous?.accountsDueDate}</td>
                    <td>{additionalInformation?.miscellaneous?.filingDateOfAccounts}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </TabPanel>
        </Tabs>
      </div>
    </div>
  );
};

export default AddtionalInformation;
